var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNextLabel = function SvgNextLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.112,
    height: 12.181
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52",
    d: "M7.112 6.09a1 1 0 0 0-.294-.709L1.705.291A1 1 0 0 0 .294 1.709l4.4 4.382-4.4 4.382a1 1 0 1 0 1.411 1.417L6.818 6.8a1 1 0 0 0 .294-.71Z",
    fill: "currentColor"
  })));
};
export default SvgNextLabel;